import { CheckIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface SaveChangesDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SaveChangesDialog: React.FC<SaveChangesDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleOkClick = () => {
    onClose();
    navigate('/client');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="flex flex-col py-4 bg-white rounded-md shadow-lg w-1/3">
        <div className="flex justify-start px-4 pb-4">
          <h4 className="text-title">Success</h4>
        </div>
        <div className="border-y w-full flex flex-col items-center justify-center py-4">
          <CheckIcon className="bg-[#67B926] rounded-full text-white h-24 p-4" />
          <p className="py-4 text-center whitespace-nowrap">
            Your changes have been saved successfully
          </p>
        </div>
        <div className="flex justify-end mt-4 w-full px-4">
          <button
            className="bg-primary/300 text-white w-full py-2 rounded-md"
            onClick={handleOkClick}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveChangesDialog;
